// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kq-1";
export var messageSideRight = "_kq-2";
export var orderLookupBubbleContainer = "_kq-0";
export var submitButton = "_kq-3";